export const SELF_VARIATION = ['flex-end', 'flex-start', 'center', 'auto', 'baseline', 'stretch', '']
export const TAG_VARIATION = ['div', 'header', 'nav', 'section', 'article', 'aside', 'footer']
